import React, { FC } from 'react';
import classNames from 'classnames';
import Style from './InfoContainer.module.scss';

interface Props {
  children: JSX.Element | JSX.Element[];
  isWarning?: boolean;
  isTransparent?: boolean;
  style?: {};
}

export const InfoContainer: FC<Props> = ({ children, isWarning = false, isTransparent = false, style = {} }) => {
  return (
    <div
      style={style}
      className={classNames(Style.info_wrap, {
        [Style.info_err]: isWarning,
      })}
    >
      <div className={classNames(Style.info_cont, {[Style.transparent_cont]: isTransparent})}>
        { children }
      </div>
    </div>
  );
};
